import BaseToggleButton, {
  ButtonProps,
} from "features/CenterContent/shared/Tabs/BaseToggleButton";

const CollapseButton = (props: ButtonProps) =>
  BaseToggleButton({ ...props, toggleType: "collapse" });

export default CollapseButton;
